import { FALLBACK_MODEL_ACTION_TAGS } from 'state/actionDefinitions'
import { LEGACY_ACTION_TAG_ALIASES, findModelByActionTag, normalizeActionTag } from 'state/aiModels'
import { FILM_DEFAULT_DURATION_SECONDS } from 'components/answers/postMediaActions'

const LEGACY_MODEL_ACTION_TAGS = new Set([
    ...FALLBACK_MODEL_ACTION_TAGS,
    ...Object.keys(LEGACY_ACTION_TAG_ALIASES),
])

// Kept in this leaf module (no component/scss imports) so unit tests can load it.
export const COMMAND_TAG_PREVIEW_CONFIG_OVERRIDES = {
    illustrate: {
        modelType: 'image',
        supportedInputs: ['text', 'image', 'video', 'audio'],
        supportsReferences: true,
    },
    film: {
        modelType: 'video',
        supportedInputs: ['text', 'image', 'video', 'audio'],
        supportsReferences: true,
        defaultSettings: {
            durationSeconds: FILM_DEFAULT_DURATION_SECONDS,
        },
    },
    nb: {
        modelType: 'image',
        supportedInputs: ['text', 'image', 'audio'],
        supportsReferences: true,
    },
    gif: {
        modelType: 'image',
        supportedInputs: ['video'],
        defaultSettings: {
            gifFrameRate: 15,
            gifMaxWidth: 720,
        },
    },
    screenshot: {
        modelType: 'image',
        supportedInputs: ['video'],
        defaultSettings: {
            screenshotTimestamp: '00:00',
        },
    },
    stitch: {
        modelType: 'video',
        supportedInputs: [],
        supportsReferences: false,
    },
    extend: {
        modelType: 'video',
        supportedInputs: ['video', 'text'],
    },
    suno: {
        modelType: 'audio',
        supportedInputs: ['text', 'audio'],
    },
    minimaxmusic: {
        modelType: 'audio',
        supportedInputs: ['text', 'audio'],
    },
}

export const isKnownActionTag = (tag, aiModels = []) => {
    const normalizedTag = normalizeActionTag(tag)
    if (!normalizedTag) return false

    return !!(
        COMMAND_TAG_PREVIEW_CONFIG_OVERRIDES[normalizedTag] ||
        LEGACY_MODEL_ACTION_TAGS.has(normalizedTag) ||
        findModelByActionTag(aiModels || [], normalizedTag)
    )
}
